import { TIIndicatorPointToHighChartIndicatorPointMapper } from '../../mappers/data-point/ti-indicator-point-to-highchart-indicator-point.mapper';
import { TIIndicatorDataModel } from '../../models/data-point/ti-indicator-data.model';
import { IndicatorOptionModel } from '../../models/drop-down-list/indicator-option.model';
import { IComponent } from "../component.interface";
import { TiChartSeriesComponent } from '../ti-chart-series.component';

export class KeltnerIndicatorComponent implements IComponent {
    public id = '';

    private tiChartSeries: TiChartSeriesComponent;

    constructor(tiChartSeries: TiChartSeriesComponent) {
        this.tiChartSeries = tiChartSeries;
    }

    public updateChildrenIndicators(indicatorData: TIIndicatorDataModel, indicatorOption: IndicatorOptionModel, tiIndicatorDataIndex: number, isUpdate: boolean) {
        const bottomSeries = this.tiChartSeries.highStockChart.series.find((x: any) => x.name.indexOf('KELTNER_B') >= 0);
        const bottom = indicatorData.childIndicators.find((x: TIIndicatorDataModel) => x.name.indexOf('KELTNER_B') >= 0);
        const tiIndicatorBBBottomIndex = this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators.findIndex((x: TIIndicatorDataModel) => x.name.indexOf('KELTNER_B') >= 0);
        if (!bottom || !bottomSeries || tiIndicatorBBBottomIndex <= - 1) {
            return;
        }

        const indicatorDataPoint = bottom.points?.length ? bottom.points[bottom.points.length - 1] : null;
        if (!indicatorDataPoint) {
            return;
        }

        const needZone = bottom.needHighChartZone(bottomSeries.type);
        if (isUpdate) {
            const lastChartBar = bottomSeries.points.find((x: any) => x.x == indicatorDataPoint.xValue);
            const tiIndicatorDataPointIndex = this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorBBBottomIndex].points.findIndex(x => x.xValue == indicatorDataPoint.xValue);
            // update to main ti indicator data points
            if (tiIndicatorDataPointIndex > -1) {
                this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorBBBottomIndex].points[tiIndicatorDataPointIndex] = indicatorDataPoint;
            }

            if (!lastChartBar) {
                const dataPoints = TIIndicatorPointToHighChartIndicatorPointMapper.map(this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorBBBottomIndex], indicatorOption.value, true);
                bottomSeries.setData(dataPoints.points, true, false, true);
                this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorBBBottomIndex].zones = dataPoints.zones;
            } else {
                const lastHighChartDataPoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartIndicatorPoint(indicatorOption.value, indicatorDataPoint, bottom);
                lastChartBar.update(lastHighChartDataPoint, false);

                // const existingZoneIndex = this.tiIndicatorsData[tiIndicatorDataIndex].zones.findIndex((x: any) => x.value == indicatorDataPoint.xValue);
                // if (existingZoneIndex > -1) {
                //     // const lastHighChartZoneDataPoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartZone(indicatorDataPoint);
                //     // this.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorBBBottomIndex].zones[existingZoneIndex] = lastHighChartZoneDataPoint;
                // }

                if (needZone) {
                    const existingZoneIndex = this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].zones.findIndex((x: any) => x.value == indicatorDataPoint.xValue);
                    if (existingZoneIndex > -1) {
                        const lastHighChartZoneDataPoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartZone(indicatorDataPoint, this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex]);
                        this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorBBBottomIndex].zones[existingZoneIndex] = lastHighChartZoneDataPoint;
                    }
                }
            }
        } else {
            const highChartDataPoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartIndicatorPoint(indicatorOption.value, indicatorDataPoint, bottom);
            bottomSeries.addPoint(highChartDataPoint, false);
            this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorBBBottomIndex].points.push(indicatorDataPoint);

            if (needZone) {
                const lastHighChartZoneDataPoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartZone(indicatorDataPoint, this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex]);
                this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorBBBottomIndex].zones.push(lastHighChartZoneDataPoint);
            }
        }

        if (needZone) {
            bottomSeries.update({
                zones: this.tiChartSeries.tiIndicatorsData[tiIndicatorDataIndex].childIndicators[tiIndicatorBBBottomIndex].zones,
                type: bottomSeries.type == 'line' ? 'line' : 'spline',
                zoneAxis: 'x'
            });
        }
    }

    public updateHistoryChildrenIndicators(indicatorData: TIIndicatorDataModel, indicatorOption: IndicatorOptionModel, firstPoint: number) {
        const bottomSeries = this.tiChartSeries.highStockChart.series.find((x: any) => x.name.indexOf('KELTNER_B') >= 0);
        const bottom = indicatorData.childIndicators.find((x: TIIndicatorDataModel) => x.name.indexOf('KELTNER_B') >= 0);
        if (!bottom || !bottomSeries) {
            return;
        }

        const needZone = bottom.needHighChartZone(bottomSeries.type);
        for (let j = bottom.points.length - 1; j > 0; j--) {
            const indicatorDataPoint = bottom.points[j];
            if (indicatorDataPoint.timestamp && indicatorDataPoint.xValue < firstPoint) {
                const point = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartIndicatorPoint(indicatorOption.value, indicatorDataPoint, bottom);
                bottomSeries.addPoint(point, false);
                if (needZone) {
                    const zonePoint = TIIndicatorPointToHighChartIndicatorPointMapper.toHighChartZone(indicatorDataPoint, indicatorData);
                    bottom.zones.unshift(zonePoint);
                }
            }
        }
        
        if (needZone) {
            bottomSeries?.update({
                zones: bottom.zones,
                type: bottomSeries.type == 'line' ? 'line' : 'spline',
                zoneAxis: 'x'
            }, false);
        }
    }
}